const { toBool, toDate, toFloat, toString } = require('@/functions/transform');

class ClubcardToken {
    constructor() {
        /**
         * @type {string}
         */
        this.code = '';

        /**
         * @type {string}
         */
        this.productCode = '';

        /**
         * @type {string}
         */
        this.status = '';

        /**
         * @type {null}
         */
        this.expiresAt = null;

        /**
         * @type {boolean}
         */
        this.expired = false;

        /**
         * @type {number}
         */
        this.value = 0.00;

        /**
         * @type {boolean}
         */
        this.redeemable = false;

        /**
         * @type {boolean}
         */
        this.redeemed = false;

        /**
         * @type {null}
         */
        this.redeemedAt = null;
    }

    getHydrationMap() {
        return {
            code: toString,
            productCode: toString,
            status: toString,
            expiresAt: toDate,
            expired: toBool,
            value: toFloat,
            redeemable: toBool,
            redeemed: toBool,
            redeemedAt: toDate,
        };
    }
}

module.exports = ClubcardToken;
